import { render, staticRenderFns } from "./userSidebar.vue?vue&type=template&id=e4d34e5a&scoped=true&"
import script from "./userSidebar.vue?vue&type=script&lang=js&"
export * from "./userSidebar.vue?vue&type=script&lang=js&"
import style0 from "./userSidebar.vue?vue&type=style&index=0&id=e4d34e5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d34e5a",
  null
  
)

export default component.exports